import { LayoutCol, LayoutRow } from '@/components/Elements/Layout';
import { SettingsSidebar } from './SettingsSideBar';

export const SettingsLayout = ({ children }) => {
  return (
    <LayoutRow cols={12}>
      <LayoutCol
        span={2}
        lg={2}
        className="border-r border-r-pv-neutral-grey-100 h-screen overflow-y-hidden"
      >
        <SettingsSidebar />
      </LayoutCol>
      <LayoutCol
        span={9}
        lg={10}
        className={`overflow-y-auto bg-brand-layout-light transition-all duration-300 col-span-10`}
      >
        {children}
      </LayoutCol>
    </LayoutRow>
  );
};
